import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { cartKey } from "@/lib/pricing";
import { toast } from "sonner";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const CART_KEY = "redeye_cart";

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch { return []; }
  });
  const [navOpen, setNavOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) { /* noop */ }
  }, []);

  useEffect(() => { loadSettings(); }, [loadSettings]);
  useEffect(() => { localStorage.setItem(CART_KEY, JSON.stringify(cart)); }, [cart]);

  const addToCart = (product, qty = 1, variant = null) => {
    const key = cartKey(product.id, variant?.label);
    setCart((prev) => {
      const idx = prev.findIndex((c) => c.key === key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + qty };
        return copy;
      }
      return [...prev, { key, product, qty, variant }];
    });
    toast.success(`${product.name}${variant ? ` (${variant.label})` : ""} added to list`);
  };

  const setQty = (key, qty) => {
    setCart((prev) => prev.map((c) => (c.key === key ? { ...c, qty: Math.max(1, qty) } : c)));
  };

  const removeItem = (key) => setCart((prev) => prev.filter((c) => c.key !== key));
  const clearCart = () => setCart([]);

  const cartCount = cart.reduce((s, c) => s + c.qty, 0);

  return (
    <StoreContext.Provider value={{
      settings, loadSettings, cart, addToCart, setQty, removeItem, clearCart, cartCount,
      navOpen, setNavOpen, cartOpen, setCartOpen,
    }}>
      {children}
    </StoreContext.Provider>
  );
}
